// clients
import { client } from "../client";
import { store } from "../store/configureStore";

// graphql
import { GET_REPORT_GROUPS_LIST, GENERATE_REPORT } from "../graphql/reports";

// utils
import { msaagesArrayToHtml } from "../atlas-utils";

// actions
import { toggleGlobalLoader } from "./actions";
import { ActionTypes } from "./_types";

export const fetchReportsList = async () => {
	store.dispatch(toggleGlobalLoader(true));
	store.dispatch({
		type: ActionTypes.GET_REPORTS_LIST_REQUEST
	});
	try {
		const resp = await client.query({
			query: GET_REPORT_GROUPS_LIST,
			fetchPolicy: "no-cache"
		});
		store.dispatch({
			type: ActionTypes.GET_REPORTS_LIST_SUCCESS,
			payload: resp.data.reportGroups
		});
	} catch (error) {
		console.log(error);
		store.dispatch({
			type: ActionTypes.GET_REPORTS_LIST_FAILURE,
			error
		});
		store.dispatch({
			type: ActionTypes.SHOW_GLOBAL_MESSAGE,
			payload: {
				message: error.message || "Something went wrong.",
				timeout: 5000,
				error: true,
				errObject: error
			}
		});
	}
	store.dispatch(toggleGlobalLoader(false));
};

export const generateReport = async (variables) => {
	try {
		const resp = await client.mutate({
			mutation: GENERATE_REPORT,
			variables: { input: variables }
		});
		if (resp.data.generateReport.status.success) {
			store.dispatch({
				type: ActionTypes.SHOW_GLOBAL_MESSAGE,
				payload: {
					message: msaagesArrayToHtml(resp.data.generateReport.status.messages),
					timeout: 5000,
					error: false
				}
			});
		} else {
			// handle error message
			store.dispatch({
				type: ActionTypes.SHOW_GLOBAL_MESSAGE,
				payload: {
					message: msaagesArrayToHtml(resp.data.generateReport.status.messages),
					timeout: 3000,
					error: true
				}
			});
		}
		return resp.data.generateReport.status;
	} catch (error) {
		console.log(error);
		store.dispatch({
			type: ActionTypes.SHOW_GLOBAL_MESSAGE,
			payload: {
				message: error.message || "Something went wrong.",
				timeout: 2000,
				error: true,
				errObject: error
			}
		});
	}
};
